import React, { useState } from "react";

// Components
import PageHeader from "~/common/components/PageHeader";
import NavbarAndSidebarLayout from "~/layouts/NavbarAndSidebarLayout";

// Assets
import "~/assets/sass/pages/round/common/applicantList.scss";
import roundImg from "~/assets/img/vq_thumb.jpg";
import {
	ExcelIcon,
	PaginationEdgeIcon,
	PaginationIcon,
	SearchIcon,
} from "~/assets/svg/InterfaceIcon";
import logoImg from "~/assets/img/defaultImg/dark-logo-square.png";
import ModalTemplate from "~/common/components/ModalPortal/ModalTemplate";

const ApplyResult = () => {
	const headerButtons = [
		<button type="button" className="btn-circle">
			<ExcelIcon />
		</button>,
		<button type="button" className="btn__solid" color="primary">
			뒤로가기
		</button>,
	];

	const [applyResultModal, setApplyResultModal] = useState();
	const [companyDetailModal, setCompanyDetailModal] = useState();

	return (
		<NavbarAndSidebarLayout
			menu={["round", "management"]}
			type={"main"}
			menuName={"apply-result"}
		>
			<PageHeader buttonList={headerButtons} />
			<div className="c__both-side-cardRow apply-result-wrap">
				<div className="c__card left">
					<div className="img-wrap">
						<img src={roundImg} alt="지원 프로그램 이미지" />
					</div>
					<div className="round-info">
						<h3 className="round-title">
							미디어 콘텐츠 스타트업 액셀러레이션 프로그램
						</h3>
						<div className="info-wrap">
							<p>지원기간 : 2020-06-04 ~ 2022-07-11</p>
							<p>주체 : 벤처스퀘어</p>
						</div>
						<div className="state-wrap">
							<dl className="round-state">
								<dt>참가기업</dt>
								<dd>17</dd>
							</dl>
						</div>
					</div>
				</div>
				<div className="c__card right">
					<div className="c__table">
						<div className="list-top">
							<div className="c__search">
								<input className="c__input" placeholder="기업명" />
								<button type="button" className="btn-search">
									<SearchIcon />
								</button>
							</div>
						</div>
						<div className="thead">
							<div className="tr">
								<div className="th company-num">No</div>
								<div className="th company-profile">기업명</div>
								<div className="th company-ceo">대표</div>
								<div className="th company-kind">기업정보</div>
							</div>
						</div>
						<div className="tbody">
							<div className="tr" onClick={() => setApplyResultModal(true)}>
								<div className="td company-num">1</div>
								<div className="td company-profile">
									<div className="img-wrap">
										<img src={logoImg} alt="회사로고" />
									</div>
									<div className="company-name">일루넥스</div>
								</div>
								<div className="td company-ceo">홍길동</div>
								<div className="td company-kind">응용소프트웨어 개발 및 공급업</div>
							</div>
							<div className="tr">
								<div className="td company-num">1</div>
								<div className="td company-profile">
									<div className="img-wrap">
										<img src={logoImg} alt="회사로고" />
									</div>
									<div className="company-name">일루넥스</div>
								</div>
								<div className="td company-ceo">홍길동</div>
								<div className="td company-kind">응용소프트웨어 개발 및 공급업</div>
							</div>
							<div className="tr">
								<div className="td company-num">1</div>
								<div className="td company-profile">
									<div className="img-wrap">
										<img src={logoImg} alt="회사로고" />
									</div>
									<div className="company-name">일루넥스</div>
								</div>
								<div className="td company-ceo">홍길동</div>
								<div className="td company-kind">응용소프트웨어 개발 및 공급업</div>
							</div>
							<div className="tr">
								<div className="td company-num">1</div>
								<div className="td company-profile">
									<div className="img-wrap">
										<img src={logoImg} alt="회사로고" />
									</div>
									<div className="company-name">일루넥스</div>
								</div>
								<div className="td company-ceo">홍길동</div>
								<div className="td company-kind">응용소프트웨어 개발 및 공급업</div>
							</div>
							<div className="tr">
								<div className="td company-num">1</div>
								<div className="td company-profile">
									<div className="img-wrap">
										<img src={logoImg} alt="회사로고" />
									</div>
									<div className="company-name">일루넥스</div>
								</div>
								<div className="td company-ceo">홍길동</div>
								<div className="td company-kind">응용소프트웨어 개발 및 공급업</div>
							</div>
							<div className="tr">
								<div className="td company-num">1</div>
								<div className="td company-profile">
									<div className="img-wrap">
										<img src={logoImg} alt="회사로고" />
									</div>
									<div className="company-name">일루넥스</div>
								</div>
								<div className="td company-ceo">홍길동</div>
								<div className="td company-kind">응용소프트웨어 개발 및 공급업</div>
							</div>
							<div className="tr">
								<div className="td company-num">1</div>
								<div className="td company-profile">
									<div className="img-wrap">
										<img src={logoImg} alt="회사로고" />
									</div>
									<div className="company-name">일루넥스</div>
								</div>
								<div className="td company-ceo">홍길동</div>
								<div className="td company-kind">응용소프트웨어 개발 및 공급업</div>
							</div>
							<div className="tr">
								<div className="td company-num">1</div>
								<div className="td company-profile">
									<div className="img-wrap">
										<img src={logoImg} alt="회사로고" />
									</div>
									<div className="company-name">일루넥스</div>
								</div>
								<div className="td company-ceo">홍길동</div>
								<div className="td company-kind">응용소프트웨어 개발 및 공급업</div>
							</div>
							<div className="tr">
								<div className="td company-num">1</div>
								<div className="td company-profile">
									<div className="img-wrap">
										<img src={logoImg} alt="회사로고" />
									</div>
									<div className="company-name">일루넥스</div>
								</div>
								<div className="td company-ceo">홍길동</div>
								<div className="td company-kind">응용소프트웨어 개발 및 공급업</div>
							</div>
							<div className="tr">
								<div className="td company-num">1</div>
								<div className="td company-profile">
									<div className="img-wrap">
										<img src={logoImg} alt="회사로고" />
									</div>
									<div className="company-name">일루넥스</div>
								</div>
								<div className="td company-ceo">홍길동</div>
								<div className="td company-kind">응용소프트웨어 개발 및 공급업</div>
							</div>
						</div>
					</div>
					<div className="pagination">
						<button type="button" className="first-btn">
							<PaginationEdgeIcon />
						</button>
						<button type="button" className="prev-btn">
							<PaginationIcon />
						</button>
						<button type="button" className={`btn-num active`}>
							1
						</button>
						<button type="button" className="next-btn">
							<PaginationIcon />
						</button>
						<button type="button" className="last-btn">
							<PaginationEdgeIcon />
						</button>
					</div>
				</div>
			</div>

			{/*---- 참여기업 모달*/}
			<ModalTemplate
				modalState={applyResultModal}
				setModalToggle={setApplyResultModal}
				title={
					<>
						참여기업 <span>관광분야 액셀러레이팅 프로그램 데모데이</span>
					</>
				}
				width={990}
				height={930}
				className="apply-result-modal"
			>
				<div className="arrow-btn prev-btn">
					<PaginationIcon />
				</div>
				<div className="modal-content apply-result-content">
					<div className="applicant-info">
						<div className="company-info-wrap">
							<div className="img-wrap">
								<img src={logoImg} alt="회사로고" />
							</div>
							<div className="company-info">
								<h4 className="company-name">(주)모먼트스튜디오</h4>
								<span className="company-abst">서울 / 2년 7개월 / 여행사업</span>
							</div>
						</div>
						<button
							className="btn__outline angled"
							color="primary"
							onClick={() => setCompanyDetailModal(true)}
						>
							기업정보
						</button>
					</div>
					<section>
						<h3 className="section-title">이용약관 동의</h3>
						<div className="c__form">
							<div className="f__group">
								<div className="f__label">개인정보수집 및 이용 동의서</div>
								<div className="f__control">미동의</div>
							</div>
						</div>
					</section>
					<section>
						<h3 className="section-title">참여기업 정보</h3>
						<div className="c__form">
							<div className="f__group">
								<div className="f__label">신청자 구분</div>
								<div className="f__control">개인 사업자</div>
							</div>
							<div className="f__group">
								<div className="f__label">회사명</div>
								<div className="f__control">앤비유</div>
							</div>
							<div className="f__group">
								<div className="f__label">대표자명</div>
								<div className="f__control">백범현</div>
							</div>
							<div className="f__group">
								<div className="f__label">담당자 연락처</div>
								<div className="f__control">010-1234-1234</div>
							</div>
							<div className="f__group">
								<div className="f__label">담당자 이메일</div>
								<div className="f__control">abcd@gmail.com</div>
							</div>
							<div className="f__group">
								<div className="f__label">지원 프로젝트명(서비스명)</div>
								<div className="f__control">KOL 컨텐츠 마케팅</div>
							</div>
							<div className="f__group">
								<div className="f__label">사업 및 주요제품 서비스 소개</div>
								<div className="f__control">
									공정한 수익 배분을 위한 블록체인 기반 음악 협업 창작 및 스트리밍
									플랫폼
								</div>
							</div>
							<div className="f__group">
								<div className="f__label">설립년월</div>
								<div className="f__control">2020-06-03</div>
							</div>
							<div className="f__group">
								<div className="f__label">오피스 위치</div>
								<div className="f__control">
									(05854) 서울특별시 송파구 법원로 C동 1234호
								</div>
							</div>
							<div className="f__group">
								<div className="f__label">설립자본금</div>
								<div className="f__control">50000</div>
							</div>
							<div className="f__group">
								<div className="f__label">직원 수</div>
								<div className="f__control">1</div>
							</div>
							<div className="f__group">
								<div className="f__label">신청자 구분</div>
								<div className="f__control">미동의</div>
							</div>
							<div className="f__group">
								<div className="f__label">시장현황</div>
								<div className="f__control">음악 크리에이터 성공 사례증가</div>
							</div>
							<div className="f__group">
								<div className="f__label">문제점</div>
								<div className="f__control">
									1. 정산방식의 문제
									<br /> 2. 낮은 수익의 문제
								</div>
							</div>
							<div className="f__group">
								<div className="f__label">솔루션</div>
								<div className="f__control">
									1. 합리적인 정산 방식 및 공정하고 투명한 수익 배분 제공
									<br />
									2. 크리에이터들의 수익 극대화
								</div>
							</div>
							<div className="f__group">
								<div className="f__label">팀구성 및 소개</div>
								<div className="f__control">
									1. 백범현
									<br />
									2. 박훈
								</div>
							</div>
							<div className="f__group">
								<div className="f__label">기술설명</div>
								<div className="f__control">
									1. 블록체인 참여자 식별 및 접근통제 기술
								</div>
							</div>
							<div className="f__group">
								<div className="f__label">사업모델 및 주요제품/서비스 소개</div>
								<div className="f__control">
									1. 비즈니스 모델 <br /> - 저작권료: 크리에이터 (80%), 플랫폼
									서비스 (20%)
									<br /> - 광고료: 크리에이터(60%), 플랫폼 서비스 (40%)
									<br /> - 수수료: 환전 수수료 (10%, 아이템을 현금화 할 시),
									온라인 서비스 (ex. 온라인 계약서 업체, 법률 자문 업체 등) 수수료
									10%
									<br /> - 크라우드 펀딩: 콘텐츠 사용자 ?> 크리에이터 ?> 콘텐츠
									증가 ?> 사용자 증가 ?> 크리에이터 증가
								</div>
							</div>
						</div>
					</section>
					<section>
						<h3 className="section-title">제출자료</h3>
						<div className="c__form">
							<div className="f__group">
								<div className="f__label">사업자등록증</div>
								<div className="f__control">
									<a href="/">(주)빛글림_사업자등록증</a>
								</div>
							</div>
							<div className="f__group">
								<div className="f__label">회사/서비스 소개서(첨부파일)</div>
								<div className="f__control">
									<a href="/">(주)빛글림_사업자등록증(첨부파일)</a>
								</div>
							</div>
							<div className="f__group">
								<div className="f__label">회사/서비스 소개서(파일링크)</div>
								<div className="f__control">
									<a href="/" />
								</div>
							</div>
						</div>
					</section>
				</div>
				<div className="arrow-btn next-btn">
					<PaginationIcon />
				</div>
			</ModalTemplate>

			{/*----기업정보 모달*/}
			<ModalTemplate
				modalState={companyDetailModal}
				setModalToggle={setCompanyDetailModal}
				title="앤비유"
				width={640}
				className="company-detail-modal"
			>
				<div className="modal-content">
					<div className="c__form">
						<div className="f__group">
							<div className="f__label">대표</div>
							<div className="f__control">백범현</div>
						</div>
						<div className="f__group">
							<div className="f__label">매출</div>
							<div className="f__control">0 (2019년 기준)</div>
						</div>
						<div className="f__group">
							<div className="f__label">업종</div>
							<div className="f__control">정보통신업</div>
						</div>
						<div className="f__group">
							<div className="f__label">설립일자</div>
							<div className="f__control">2020-06-03</div>
						</div>
						<div className="f__group">
							<div className="f__label">직원 수</div>
							<div className="f__control">1</div>
						</div>
						<div className="f__group">
							<div className="f__label">기업구분</div>
							<div className="f__control">개인 사업자</div>
						</div>
						<div className="f__group">
							<div className="f__label">국가</div>
							<div className="f__control">한국</div>
						</div>
						<div className="f__group">
							<div className="f__label">상장구분</div>
							<div className="f__control">비상장</div>
						</div>
						<div className="f__group">
							<div className="f__label">주소</div>
							<div className="f__control">
								(05854) 서울특별시 송파구 법원로 C동 1234호
							</div>
						</div>
						<div className="f__group">
							<div className="f__label">홈페이지</div>
							<div className="f__control">https://www.sampleer.com</div>
						</div>
					</div>
					<div className="c__form vertical">
						<div className="f__group major-product">
							<div className="f__label">
								주요제품 <span>샘플리어</span>
							</div>
							<div className="f__control">
								샘플링으로 인한 음악 저작권 문제를 해결하는 샘플 클리어 서비스
							</div>
						</div>
					</div>
				</div>
				<div className="modal-footer">
					<button
						type="button"
						className="btn__solid"
						color="primary"
						onClick={() => setCompanyDetailModal(false)}
					>
						닫기
					</button>
				</div>
			</ModalTemplate>
		</NavbarAndSidebarLayout>
	);
};

export default ApplyResult;
